/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Chip_50kInputs */

const tr_landing_genius_chip_50k = /** @type {(inputs: Landing_Genius_Chip_50kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50K kredi`)
};

const en_landing_genius_chip_50k = /** @type {(inputs: Landing_Genius_Chip_50kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50K credits`)
};

const de_landing_genius_chip_50k = /** @type {(inputs: Landing_Genius_Chip_50kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50K Credits`)
};

const ru_landing_genius_chip_50k = /** @type {(inputs: Landing_Genius_Chip_50kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50K кредитов`)
};

/**
* | output |
* | --- |
* | "50K credits" |
*
* @param {Landing_Genius_Chip_50kInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_chip_50k = /** @type {((inputs?: Landing_Genius_Chip_50kInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Chip_50kInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_chip_50k(inputs)
	if (locale === "de") return de_landing_genius_chip_50k(inputs)
	if (locale === "ru") return ru_landing_genius_chip_50k(inputs)
	return tr_landing_genius_chip_50k(inputs)
});